<template>
  <div>
    <v-layout>
      <v-flex xs12 sm6 class="my-3">
        <v-list>
          <v-list-tile @click="" v-if="ready"
                       v-for="item in sellTagArr"
                       :key="item.displayName"
                       no-action
                       class="my-2 elevation-5"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.displayName }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-layout row>
                <v-btn
                  color="error"
                  fab flat
                  @click.stop="deleted(item)"
                  :disabled="!isWriteAvailable"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-layout>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm6>
      <v-select
        label="Add SELL Killer Feature"
        :items="anotherTagArr"
        v-model="items"
        max-height="400"
        persistent-hint
        :disabled="!isWriteAvailable"
      ></v-select>
    </v-flex>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import mixins from '@/utils/mixins'

  export default {
    name: 'sellTag',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        ready: false,
        sellTagArr: [],
        anotherTagArr: [],
        items: '',
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters(['tags'])
    },
    watch: {
      items (val) {
        if (!val) return
        let addTag = this.tags.filter(option => option.displayName === val)
        this.update(...addTag)
      }
    },
    methods: {
      ...mapActions([
        'getTag',
        'putTagType',
        'showResultErrorMessage'
      ]),
      async update ({ id, type }) {
        try {
          await this.putTagType({ id, type: type ? 'Buy, Sell' : 'Sell' })
          await this.getTypes()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
      async deleted ({ id, type }) {
        try {
          await this.putTagType({ id, type: type.indexOf('Buy') !== -1 ? 'Buy' : '' })
          await this.getTypes()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
      async getTypes () {
        await this.getTag()
        this.sellTagArr = []
        this.anotherTagArr = []
        this.items = ''
        this.tags.forEach(val => {
          if (val.type && val.type.indexOf("Sell") !== -1) this.sellTagArr.push(val)
          else this.anotherTagArr.push(val.displayName)
        })
        this.ready = true
      }
    },
    beforeMount () {
      this.getTypes()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/Registration/KillerFeature/KFSell.vue